//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  name: "common-default-images",
  props: {
    type: {
      type: Number,
      default: 9,
    },
    from: {
      type: Number,
      default: 0,
    },
    width: {
      type: Boolean,
      default: false,
    },
  },
  methods: {
    changeTrue() {
      console.log(this.from)

      if (this.from == 0) {
        this.$router.push({
          path: "/fkxx",
          query: {
            model: 0,
          },
        });
      }
      if (this.from == 1) {
        this.$router.push({
          path: "/fkxx",
          query: {
            model: 1,
            total:0
          },
        });
      } else if (this.from == 2) {
        this.$router.push({
          path: "/fkxx",
          query: {
            model: 2,
            total:0
          },
        });
      } else if (this.from == 3) {
        this.$router.push({
          path: "/fkxx",
          query: {
            model: 3,
            total:0
          },
        });
      }
    },
  },
};



// WEBPACK FOOTER //
// ./src/components/common-default-images.vue